import React from 'react'
import {
  ThemeProvider,
  Logo,
  Box,
  IconManager,
  deseretBookLogoPack,
  styled,
  Link,
} from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'

IconManager.register(deseretBookLogoPack)

const DbLogo = styled(Logo)({
  height: '2.5rem',
  circle: {
    fill: 'transparent',
  },
})

/**
 * Container for db Logos.
 *
 * @returns {function} React component
 */
const LogosContainer = () => {
  const isTabletOrLarger = useMediaQuery({ minWidth: 1090 })

  return (
    <ThemeProvider theme={{ palette: { primary: '#89955d' } }}>
      <Box alignItems="center" isFullwidth>
        <Link href="/">
          <DbLogo name="db" color="light" size="large" />
        </Link>
        {isTabletOrLarger && (
          <Link href="/">
            <Logo
              name="deseretBook"
              color="light"
              size="large"
              style={{ marginLeft: '0.5rem', minWidth: '10rem' }}
            />
          </Link>
        )}
      </Box>
    </ThemeProvider>
  )
}

export default LogosContainer
